var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44358 12C8.9345 12 9.33247 12.398 9.33247 12.8889V14.6667C9.33247 16.6303 10.9243 18.2222 12.888 18.2222C14.8517 18.2222 16.4436 16.6303 16.4436 14.6667V13.7778C16.4436 13.2869 16.8415 12.8889 17.3325 12.8889C17.8234 12.8889 18.2214 13.2869 18.2214 13.7778V14.6667C18.2214 17.6122 15.8335 20 12.888 20C9.9425 20 7.55469 17.6122 7.55469 14.6667V12.8889C7.55469 12.398 7.95266 12 8.44358 12Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3327 12.8915C17.8236 12.8915 18.2216 12.4935 18.2216 12.0026C18.2216 11.5117 17.8236 11.1137 17.3327 11.1137C16.8418 11.1137 16.4438 11.5117 16.4438 12.0026C16.4438 12.4935 16.8418 12.8915 17.3327 12.8915ZM17.3327 14.6693C18.8054 14.6693 19.9993 13.4754 19.9993 12.0026C19.9993 10.5298 18.8054 9.33594 17.3327 9.33594C15.8599 9.33594 14.666 10.5298 14.666 12.0026C14.666 13.4754 15.8599 14.6693 17.3327 14.6693Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22222 5.77778C5.97676 5.77778 5.77778 5.97676 5.77778 6.22222V9.33333C5.77778 10.8061 6.97169 12 8.44444 12C9.9172 12 11.1111 10.8061 11.1111 9.33333V6.22222C11.1111 5.97676 10.9121 5.77778 10.6667 5.77778H10.2222C9.7313 5.77778 9.33333 5.37981 9.33333 4.88889C9.33333 4.39797 9.7313 4 10.2222 4H10.6667C11.894 4 12.8889 4.99492 12.8889 6.22222V9.33333C12.8889 11.7879 10.899 13.7778 8.44444 13.7778C5.98985 13.7778 4 11.7879 4 9.33333V6.22222C4 4.99492 4.99492 4 6.22222 4H6.66667C7.15759 4 7.55556 4.39797 7.55556 4.88889C7.55556 5.37981 7.15759 5.77778 6.66667 5.77778H6.22222Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.8ffffb2c4adcdd5c74cdb30b5d1f79e6.svg";
export { ForwardRef as ReactComponent };